"use client"

import ErrorPage from "@/layout/ErrorPage"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  // Prepare the data structure expected by the ErrorPage component
  const data = {
    subtitle: { value: "מצטערים, משהו השתבש" },
    text: {
      richText: `<p>לא הצלחנו להשלים את הפעולה בגלל תקלה טכנית. מזמינים אותך לנסות שוב בעוד כמה דקות.</p>`,
    },
    button: {
      links: [{ url: "/", name: "חזור לדף הבית" }],
    },
    additionalButton: {
      links: [
        {
          url: "#",
          name: "נסה שוב",
          onClick: (e: any) => {
            e?.preventDefault()
            if (typeof window !== "undefined") {
              window.location.reload()
            }
            reset()
          },
        },
      ],
    },
    image: {
      mediaItems: [{ url: "/personErrorPage.png" }],
    },
    changeSides: { value: false },
    noBackground: { value: false },
  }

  return <ErrorPage data={data} />
}
